module.exports = __webpack_public_path__ + "img/q3-a.f94d02de.jpg";